import React, { useState } from 'react';
import AdminSidebar from '../components/AdminSidebar';
import UserList from '../components/UserList';
import ConsultantAssign from '../components/ConsultantAssign';
import ConsultantList from '../components/ConsultantList';

const SIDEBAR_WIDTH = 260;
const NAVBAR_HEIGHT = 60;

const AdminDashboard = () => {
  const [section, setSection] = useState('users');

  let content = null;
  if (section === 'users') content = <UserList />;
  else if (section === 'consultants') content = <ConsultantList />;
  else if (section === 'assign') content = <ConsultantAssign />;
  else if (section === 'settings') content = <div><h3>Settings</h3><p>Admin settings go here.</p></div>;

  return (
    <div>
      <AdminSidebar section={section} setSection={setSection} />
      <main style={{
        marginLeft: SIDEBAR_WIDTH,
        marginTop: NAVBAR_HEIGHT + 16,
        padding: 20,
        minHeight: `calc(100vh - ${NAVBAR_HEIGHT + 40}px)`,
        borderRadius: 8,
        background: '#f6f8fb'
      }}>
        <div style={{ maxWidth: 1200, margin: '0 auto' }}>
          <div style={{ background: '#fff', borderRadius: 12, padding: 16, boxShadow: '0 6px 18px rgba(12,20,40,0.06)' }}>
            {content}
          </div>
        </div>
      </main>
    </div>
  );
};

export default AdminDashboard;